import { Field } from "@components/common/Field";
import { Credentials } from "@gen/agency/v1/agency_pb";

export const fieldsCredentials: (
  t: (s: string) => string,
) => Field<Credentials>[] = (t) => [
  {
    key: "instanceUrl",
    type: "text",
    label: t("admin.agency.instanceUrl"),
    placeholder: "https://instanceagencea.com",
    creation: {
      enabled: true,
      order: 0,
      rules: {
        required: t("form.fieldRequired"),
      },
    },
  },
  {
    key: "oauthUrl",
    type: "text",
    label: t("admin.agency.oauthUrl"),
    placeholder: "https://instanceserveur.com",
    creation: {
      enabled: true,
      order: 1,
      rules: {
        required: t("form.fieldRequired"),
      },
    },
  },
  {
    key: "clientId",
    type: "text",
    label: t("admin.agency.clientId"),
    placeholder: "azerty",
    creation: {
      enabled: true,
      order: 2,
      rules: {
        required: t("form.fieldRequired"),
      },
    },
  },
  {
    key: "clientSecret",
    type: "text",
    label: t("admin.agency.clientSecret"),
    placeholder: "azerty",
    creation: {
      enabled: true,
      order: 3,
      rules: {
        required: t("form.fieldRequired"),
      },
    },
  },
];
